import {
  Component,
  OnChanges,
  Input,
  SimpleChanges, OnInit,
} from '@angular/core';
import { DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import {BehaviorSubject, Observable} from "rxjs";
import { ButtonConfiguration, SharedUiButtonModule } from '@snelstart/ui-button';
import {
  BokkzAlgDataService,
  BokkzJrLogic, ClientEntity, BokkzJrDataService
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ToastService} from "@snelstart/ui-toast";
import {
  ToelichtingLeningenBestuurdersCommissarissenComponent
} from '../rapport/toelichting-leningen-bestuurders-commissarissen/toelichting-leningen-bestuurders-commissarissen.component';
import {
  ToelichtingOpAandelenGebaseerdeBetalingenComponent
} from '../rapport/toelichting-op-aandelen-gebaseerde-betalingen/toelichting-op-aandelen-gebaseerde-betalingen.component';
import {
  ToelichtingFinancieleInstrumentenComponent
} from '../rapport/toelichting-financiele-instrumenten/toelichting-financiele-instrumenten.component';
import {
  ToelichtingGemiddeldAantalWerknemersComponent
} from '../rapport/toelichting-gemiddeld-aantal-werknemers/toelichting-gemiddeld-aantal-werknemers.component';
import { ToelichtingConcessiesComponent } from '../rapport/toelichting-concessies/toelichting-concessies.component';
import {
  ToelichtingOverigeToelichtingenWinstEnVerliesrekeningComponent
} from '../rapport/toelichting-overige-toelichtingen-winst-en-verliesrekening/toelichting-overige-toelichtingen-winst-en-verliesrekening.component';
import {
  ToelichtingBijzonderePostenComponent
} from '../rapport/toelichting-bijzondere-posten/toelichting-bijzondere-posten.component';
import {
  ToelichtingNietInBalansOpgenomenActivaVerplichtingenComponent
} from '../rapport/toelichting-niet-in-balans-opgenomen-activa-verplichtingen/toelichting-niet-in-balans-opgenomen-activa-verplichtingen.component';
import { ToelichtingBalansComponent } from '../rapport/toelichting-balans/toelichting-balans.component';
import { SpecMvaComponent } from '../rapport/spec-mva/spec-mva.component';
import {
  SpecOnderhandenProjectenComponent
} from '../rapport/spec-onderhanden-projecten/spec-onderhanden-projecten.component';
import { SpecNettoOmzetComponent } from '../rapport/spec-netto-omzet/spec-netto-omzet.component';
import {
  SpecBedrijfsopbrengstenComponent
} from '../rapport/spec-bedrijfsopbrengsten/spec-bedrijfsopbrengsten.component';
import { SpecOvbatenenlastenComponent } from '../rapport/spec-ovbatenenlasten/spec-ovbatenenlasten.component';
import {
  SpecOverigeBedrijfskostenComponent
} from '../rapport/spec-overige-bedrijfskosten/spec-overige-bedrijfskosten.component';
import {
  SpecLastenPersoneelsbeloningenComponent
} from '../rapport/spec-lasten-personeelsbeloningen/spec-lasten-personeelsbeloningen.component';
import {
  SpecResultaatDeelnemingenComponent
} from '../rapport/spec-resultaat-deelnemingen/spec-resultaat-deelnemingen.component';
import { SpecVorderingenComponent } from '../rapport/spec-vorderingen/spec-vorderingen.component';
import {
  SpecVastgoedbeleggingenComponent
} from '../rapport/spec-vastgoedbeleggingen/spec-vastgoedbeleggingen.component';
import { SpecVoorraadComponent } from '../rapport/spec-voorraad/spec-voorraad.component';
import {
  SpecVrijvalUitHerwaarderingsreserveComponent
} from '../rapport/spec-vrijval-uit-herwaarderingsreserve/spec-vrijval-uit-herwaarderingsreserve.component';
import { SpecVoorzieningenComponent } from '../rapport/spec-voorzieningen/spec-voorzieningen.component';
import {
  SpecWaardeveranderingenIvaMvaComponent
} from '../rapport/spec-waardeveranderingen-iva-mva/spec-waardeveranderingen-iva-mva.component';
import {
  SpecWaardeveranderingenVastgoedbeleggingenComponent
} from '../rapport/spec-waardeveranderingen-vastgoedbeleggingen/spec-waardeveranderingen-vastgoedbeleggingen.component';
import {
  SpecWaardeverminderingVlottendeActivaComponent
} from '../rapport/spec-waardevermindering-vlottende-activa/spec-waardevermindering-vlottende-activa.component';
import { ToelichtingAlgemeenComponent } from '../rapport/toelichting-algemeen/toelichting-algemeen.component';
import {
  ToelichtingContinuiteitComponent
} from '../rapport/toelichting-continuiteit/toelichting-continuiteit.component';
import { ToelichtingSchattingenComponent } from '../rapport/toelichting-schattingen/toelichting-schattingen.component';
import {
  ToelichtingConsolidatieComponent
} from '../rapport/toelichting-consolidatie/toelichting-consolidatie.component';
import {
  ToelichtingFusiesEnOvernamesComponent
} from '../rapport/toelichting-fusies-en-overnames/toelichting-fusies-en-overnames.component';
import {
  ToelichtingBeeindigingBedrijfsactiviteitenComponent
} from '../rapport/toelichting-beeindiging-bedrijfsactiviteiten/toelichting-beeindiging-bedrijfsactiviteiten.component';
import {
  ToelichtingBezoldigingBestuurdersCommissarissenComponent
} from '../rapport/toelichting-bezoldiging-bestuurders-commissarissen/toelichting-bezoldiging-bestuurders-commissarissen.component';
import {
  ToelichtingNogNietUitgeoefendeVerleendeRechtenComponent
} from '../rapport/toelichting-nog-niet-uitgeoefende-verleende-rechten/toelichting-nog-niet-uitgeoefende-verleende-rechten.component';
import {
  ToelichtingGebeurtenissenNaBalansdatumComponent
} from '../rapport/toelichting-gebeurtenissen-na-balansdatum/toelichting-gebeurtenissen-na-balansdatum.component';
import {
  ToelichtingOverigeToelichtingenComponent
} from '../rapport/toelichting-overige-toelichtingen/toelichting-overige-toelichtingen.component';
import { ActivaComponent } from '../rapport/activa/activa.component';
import { PassivaComponent } from '../rapport/passiva/passiva.component';
import { FiscalePositieComponent } from '../rapport/fiscale-positie/fiscale-positie.component';
import { GrondslagenAlgemeenComponent } from '../rapport/grondslagen-algemeen/grondslagen-algemeen.component';
import { GrondslagenBalansComponent } from '../rapport/grondslagen-balans/grondslagen-balans.component';
import {
  GrondslagenWinstEnVerliesrekeningComponent
} from '../rapport/grondslagen-winst-en-verliesrekening/grondslagen-winst-en-verliesrekening.component';
import { InfoOndernemingComponent } from '../rapport/info-onderneming/info-onderneming.component';
import { InfoRapportageComponent } from '../rapport/info-rapportage/info-rapportage.component';
import { NubbvComponent } from '../rapport/nubbv/nubbv.component';
import { KoppelenRgsAdminComponent } from '../rapport/koppelen-rgs-admin/koppelen-rgs-admin.component';
import { ZakelijkePartnersComponent } from '../rapport/zakelijke-partners-natuurlijke-personen/zakelijke-partners.component';
import { OndertekeningRechtspersoonComponent } from '../rapport/ondertekening-rechtspersoon/ondertekening-rechtspersoon.component';
import { OndertekeningNatuurlijkePersonenComponent } from '../rapport/ondertekening-natuurlijke-personen/ondertekening-natuurlijke-personen.component';
import {
  WinstEnVerliesrekeningComponent
} from '../rapport/winst-en-verliesrekening/winst-en-verliesrekening.component';
import {
  SpecAfschrijvingenIvaMvaComponent
} from '../rapport/spec-afschrijvingen-iva-mva/spec-afschrijvingen-iva-mva.component';
import { SpecEffectenComponent } from '../rapport/spec-effecten/spec-effecten.component';
import { SpecEigenVermogenNatuurlijkePersonenComponent } from '../rapport/spec-eigen-vermogen-natuurlijke-personen/spec-eigen-vermogen-natuurlijke-personen.component';
import { SpecEigenVermogenNatuurlijkPersoonComponent } from '../rapport/spec-eigen-vermogen-natuurlijk-persoon/spec-eigen-vermogen-natuurlijk-persoon.component';
import { SpecEigenVermogenRechtspersoonComponent } from '../rapport/spec-eigen-vermogen-rechtspersoon/spec-eigen-vermogen-rechtspersoon.component';
import {
  SpecFinancieleBatenLasten
} from '../rapport/spec-financiele-baten-lasten/spec-financiele-baten-lasten.component';
import { SpecBelastingenComponent } from '../rapport/spec-belastingen/spec-belastingen.component';
import { SpecFvaComponent } from '../rapport/spec-fva/spec-fva.component';
import { SpecIvaComponent } from '../rapport/spec-iva/spec-iva.component';
import {
  SpecKostenGrondEnHulpstoffenComponent
} from '../rapport/spec-kosten-grond-en-hulpstoffen/spec-kosten-grond-en-hulpstoffen.component';
import {
  SpecKostenUitbesteedWerkComponent
} from '../rapport/spec-kosten-uitbesteed-werk/spec-kosten-uitbesteed-werk.component';
import {
  SpecKortlopendeSchuldenComponent
} from '../rapport/spec-kortlopende-schulden/spec-kortlopende-schulden.component';
import {
  SpecLanglopendeSchuldenComponent
} from '../rapport/spec-langlopende-schulden/spec-langlopende-schulden.component';
import { SpecLiquideMiddelenComponent } from '../rapport/spec-liquide-middelen/spec-liquide-middelen.component';
import { SharedUiTabModule } from '@snelstart/ui-tab';
import { CommonModule } from '@angular/common';
import {
  AccountantsverklaringGenererenComponent
} from "../rapport/accountantsverklaring-genereren/accountantsverklaring-genereren.component";
import {
  SamenstellingsverklaringComponent
} from "../rapport/samenstellingsverklaring/samenstellingsverklaring.component";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-report-details',
  templateUrl: './feature-tax-report-details.component.html',
  styleUrls: ['./feature-tax-report-details.component.scss'],
  imports: [
    CommonModule,
    AccountantsverklaringGenererenComponent,
    SamenstellingsverklaringComponent,
    ToelichtingLeningenBestuurdersCommissarissenComponent,
    ToelichtingOpAandelenGebaseerdeBetalingenComponent,
    ToelichtingFinancieleInstrumentenComponent,
    ToelichtingGemiddeldAantalWerknemersComponent,
    ToelichtingConcessiesComponent,
    ToelichtingOverigeToelichtingenWinstEnVerliesrekeningComponent,
    ToelichtingBijzonderePostenComponent,
    ToelichtingNietInBalansOpgenomenActivaVerplichtingenComponent,
    ToelichtingBalansComponent,
    SpecMvaComponent,
    SpecOnderhandenProjectenComponent,
    SpecNettoOmzetComponent,
    SpecBedrijfsopbrengstenComponent,
    SpecOvbatenenlastenComponent,
    SpecOverigeBedrijfskostenComponent,
    SpecLastenPersoneelsbeloningenComponent,
    SpecResultaatDeelnemingenComponent,
    SpecVorderingenComponent,
    SpecVastgoedbeleggingenComponent,
    SpecVoorraadComponent,
    SpecVrijvalUitHerwaarderingsreserveComponent,
    SpecVoorzieningenComponent,
    SpecWaardeveranderingenIvaMvaComponent,
    SpecWaardeveranderingenVastgoedbeleggingenComponent,
    SpecWaardeverminderingVlottendeActivaComponent,
    ToelichtingAlgemeenComponent,
    ToelichtingContinuiteitComponent,
    ToelichtingSchattingenComponent,
    ToelichtingConsolidatieComponent,
    ToelichtingFusiesEnOvernamesComponent,
    ToelichtingBeeindigingBedrijfsactiviteitenComponent,
    ToelichtingBezoldigingBestuurdersCommissarissenComponent,
    ToelichtingNogNietUitgeoefendeVerleendeRechtenComponent,
    ToelichtingGebeurtenissenNaBalansdatumComponent,
    ToelichtingOverigeToelichtingenComponent,
    SharedUiDetailsModule,
    ActivaComponent,
    PassivaComponent,
    FiscalePositieComponent,
    GrondslagenAlgemeenComponent,
    GrondslagenBalansComponent,
    GrondslagenWinstEnVerliesrekeningComponent,
    InfoOndernemingComponent,
    InfoRapportageComponent,
    NubbvComponent,
    KoppelenRgsAdminComponent,
    ZakelijkePartnersComponent,
    OndertekeningRechtspersoonComponent,
    OndertekeningNatuurlijkePersonenComponent,
    WinstEnVerliesrekeningComponent,
    SpecAfschrijvingenIvaMvaComponent,
    SpecEffectenComponent,
    SpecEigenVermogenNatuurlijkePersonenComponent,
    SpecEigenVermogenNatuurlijkPersoonComponent,
    SpecEigenVermogenRechtspersoonComponent,
    SpecFinancieleBatenLasten,
    SpecBelastingenComponent,
    SpecFvaComponent,
    SpecIvaComponent,
    SpecKostenGrondEnHulpstoffenComponent,
    SpecKostenUitbesteedWerkComponent,
    SpecKortlopendeSchuldenComponent,
    SpecLanglopendeSchuldenComponent,
    SpecLiquideMiddelenComponent,
    SharedUiButtonModule,
    SharedUiTabModule
  ]
})
export class FeatureTaxReportDetailsComponent implements OnChanges, OnInit {

  @Input() public id!: string;
  public selectedTab = new BehaviorSubject<number>(0);
  public clientEntity = {} as ClientEntity;
  public isRechtspersoon = false;
  public heeftAandelen = false;
  public isEnkelvoudig = false;
  public isFiscaleGrondslagen = false;
  public isMicro = false;
  public isKlein = false;

  private specsIds: string[] = [
    'Samenstellingsverklaring',
    'Algemene toelichting',
    'Continuïteit',
    'Schattingen',
    'Consolidatie',
    'Fusies en overnames',
    'Bedrijfsactiviteiten die niet duurzaam worden voortgezet',
    'Algemene grondslagen',
    'Immateriële vaste activa',
    'Materiële vaste activa',
    'Financiële vaste activa',
    'Vastgoedbeleggingen',
    'Voorraden',
    'Onderhanden projecten',
    'Vorderingen',
    'Effecten',
    'Liquide middelen',
    'Eigen vermogen',
    'Eigen vermogen onderneming',
    'Eigen vermogen zakelijke partner (de eigenaar, vennoot of maat)',
    'Voorzieningen',
    'Kortlopende schulden',
    'Langlopende schulden',
    'Niet in balans opgenomen activa en verplichtingen',
    'Overige toelichtingen balans',
    'Bedrijfsopbrengsten',
    'Kosten van grond- en hulpstoffen',
    'Kosten uitbesteed werk en andere externe kosten',
    'Lasten uit hoofde van personeelsbeloningen',
    'Afschrijvingen op immateriële en materiële vaste activa',
    'Waardeveranderingen van immateriële en materiële vaste activa',
    'Wijziging in de reële waarde van vastgoedbeleggingen',
    'Waardeverminderingen van vlottende activa',
    'Overige bedrijfskosten',
    'Vrijval uit herwaarderingsreserve',
    'Financiële baten en lasten',
    'Belastingen',
    'Resultaat uit deelnemingen',
    'Bijzondere posten',
    'Overige toelichtingen winst-en-verliesrekening',
    'Concessies',
    'Gemiddeld aantal werknemers',
    'Financiële instrumenten',
    'Op aandelen gebaseerde betalingen',
    'Bezoldiging bestuurders en commissarissen',
    'Leningen, voorschotten en garanties bestuurders en commissarissen',
    'Nog niet uitgeoefende verleende rechten',
    'Gebeurtenissen na balansdatum',
    'Overige toelichtingen'
  ];

  public detailsConfig = DetailsConfig.create({
    hideArrowButtons: true,
  });

  public config() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            subscription.next(true);
            subscription.complete();
            this.saveForm()
          }, 200);
        }),
    })
  }

  constructor(public dataService: BokkzJrLogic,
              private algDataService: BokkzAlgDataService,
              private jrDataService: BokkzJrDataService,
              public toastService: ToastService) {
  }

  public ngOnInit() {
    this.selectedTab.next(0)
    this.algDataService.client.subscribe((value) => {
      this.clientEntity = value;
    })
    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
    this.jrDataService.heeftAandelen.subscribe((value) => {
      this.heeftAandelen = value;
    })
    this.jrDataService.isEnkelvoudig.subscribe((value) => {
      this.isEnkelvoudig = value;
    })
    this.jrDataService.isFiscaleGrondslagen.subscribe((value) => {
      this.isFiscaleGrondslagen = value;
    })
    this.jrDataService.isMicro.subscribe((value) => {
      this.isMicro = value;
    })
    this.jrDataService.isKlein.subscribe((value) => {
      this.isKlein = value;
    })
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const idChanges = changes['id'];
    if (idChanges && idChanges.currentValue !== idChanges.previousValue) {
      this.id = idChanges.currentValue;
    }
  }

  public showSpecs(id: string): boolean {
    return this.specsIds.includes(id);
  }

  public showSpecsGrondslagen(): boolean {
    return this.id.includes("Algemene grondslagen");
  }

  public showSpecsEigenVermogenNatuurlijkePersonen(): boolean {
    return this.id.includes("Eigen vermogen onderneming");
  }

  public showSpecsEigenVermogenNatuurlijkPersoon(): boolean {
    return this.id.includes("Eigen vermogen zakelijke partner (de eigenaar, vennoot of maat)");
  }

  public showSpecsEigenVermogenRechtspersoon(): boolean {
    return this.id.includes("Eigen vermogen") &&
      !this.id.includes("natuurlijk") && !this.id.includes("onderneming") && !this.id.includes("zakelijk");
  }

  public showSpecsBedrijfsopbrengsten(): boolean {
    return this.id.includes("Bedrijfsopbrengsten");
  }

  public showSamenstellingsverklaring(): boolean {
    return this.id.includes("Samenstellingsverklaring");
  }


  public showSpecsAlleenTabTekstueleToelichting(): boolean {

    const idsAlleenTabTekstueleToelichting = [
      "Algemene toelichting",
      "Continuïteit",
      "Schattingen",
      "Consolidatie",
      "Fusies en overnames",
      "Bedrijfsactiviteiten die niet duurzaam worden voortgezet",
      "Niet in balans opgenomen activa en verplichtingen",
      "Overige toelichtingen balans",
      'Bijzondere posten',
      "Overige toelichtingen winst-en-verliesrekening",
      "Concessies",
      "Financiële instrumenten",
      "Op aandelen gebaseerde betalingen",
      "Bezoldiging bestuurders en commissarissen",
      "Leningen, voorschotten en garanties bestuurders en commissarissen",
      "Nog niet uitgeoefende verleende rechten",
      "Gebeurtenissen na balansdatum",
      "Overige toelichtingen"
    ];

    return idsAlleenTabTekstueleToelichting.some(i => this.id.includes(i));
  }

  public showSpecsAlleenTabUitsplitsing(): boolean {

    const idsAlleenTabUitsplitsing = [
      "Kosten van grond- en hulpstoffen",
      "Kosten uitbesteed werk en andere externe kosten"
    ];

    return idsAlleenTabUitsplitsing.some(i => this.id.includes(i));
  }

  public onSelectTab(tabIndex: number) {
    this.selectedTab.next(tabIndex)
  }

  public saveForm(): void {
    setTimeout(()=> {
      this.dataService.postJaarraportage(String(this.clientEntity.sstRelationId), "2011",false);
    },50)
  }
}
